import Document from "../assets/svg/tabsImg/Document.svg";
import DocumentShow from "../assets/svg/tabsImg/DocumentShow.svg";
import ImgLogoBank from "../assets/svg/ImgLogoBank.svg";
import { apiAddFinancials, apiGetFinancial, apiUpdateFinancial } from "../api/financialApi";

export const financialFormData = {
    key: "bank",
    title: "حساب",
    addFunction: apiAddFinancials,
    getFunction: apiGetFinancial,
    updateFunction: apiUpdateFinancial,
    navigation: {
        title: "افزودن حساب",
        // description: "ثبت اطلاعات حساب",
        backTitle: "بازگشت",
        backUrl: "/financials",
    },
    summaryInfo: {
        key: "bank",
        primaryTitleKey: "name",
        addTempTitle: "افزودن حساب جدید",
        saveTitle: "ذخیره حساب ها",
        defaultImage: ImgLogoBank,
    },
    tabs: [
        {
            key: "bank",
            name: "بانک",
            form: {
                main: {
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                    imagePicker: {
                        active: false,
                    },
                    accountingCode: {
                        wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 offset-1 offset-xs-0",
                        active: true,
                        primary: true,
                        type: "accountingCode",
                        label: "کد حسابداری",
                        name: "accountingCode",
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                        style: {
                            paddingRight: "60px",
                        },
                    },
                    status: {
                        active: true,
                        name: "active",
                        type: "status",
                        wrapperClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12",
                    },
                    radioInput: {
                        wrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12",
                        active: true,
                        type: "radioInput",
                        name: "default",
                        label: "پیش فرض",
                        options: [
                            {
                                title: "بله",
                                value: 1,
                            },
                            {
                                title: "خیر",
                                value: 0,
                            },
                        ],
                    },
                    inputs: [
                        {
                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12",
                            name: "name",
                            label: "نام بانک",
                            required: true,
                            primary: true,
                            maxLength: 32,
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5 style-padding-inputs",
                            name: "priceUnit",
                            type: "currency",
                            showInput: false,
                            label: "واحد پول",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12 offset-1 offset-xs-0",
                            type: "selectBox",
                            // addModal: {
                            //     props: {
                            //         component: "financial",
                            //         title: false,
                            //         closeButton: false,
                            //         onFinish: (token) => apiFinancialsList("bank", token),
                            //     },
                            // },
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                            name: "CurrencyId",
                            label: "نوع ارز",
                            primary: true,
                            showInput: true,
                            required: false,
                            options: "businessCurrencies",
                        },
                        {
                            name: "description",
                            type: "text",
                            label: "توضیحات",
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                    ],
                },
                tabs: [
                    {
                        key: "accountInformation",
                        name: "اطلاعات حساب",
                        imgUrl: Document,
                        imgUrlShow: DocumentShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "branch",
                                label: "شعبه",
                                maxLength: 32,
                                placeholder: "شعبه میرداماد",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "accountNumber",
                                type: "number",
                                label: "شماره حساب",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "cardNumber",
                                type: "number",
                                label: "شماره کارت",
                                maxLength: 20,
                                placeholder: "1234-5678-1234-5678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "shaba",
                                label: "شماره شبا",
                                maxLength: 64,
                                placeholder: "1234567890 (بدون IR)",
                            },
                        ],
                    },
                    {
                        key: "taxInformation",
                        name: "سامانه مودیان",
                        imgUrl: Document,
                        imgUrlShow: DocumentShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "taxMobile",
                                label: "شماره موبایل اینترنت بانک",
                                placeholder: "*******0912",
                                maxLength: 14,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "taxPaymentSwitch",
                                type: "number",
                                label: "شماره سوئیچ پرداخت",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "taxPaymentTerminal",
                                type: "number",
                                label: "شماره ترمینال پرداخت",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "number",
                                name: "taxStoreReceiverNumber",
                                label: "شماره پذیرنده فروشگاهی",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                        ],
                    },
                ],
            },
        },
        {
            key: "fund",
            name: "تنخواه گردان",
            form: {
                main: {
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                    imagePicker: {
                        active: false,
                    },
                    accountingCode: {
                        wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 offset-1 offset-xs-0",
                        active: true,
                        primary: true,
                        type: "accountingCode",
                        label: "کد حسابداری",
                        name: "accountingCode",
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                        style: {
                            paddingRight: "60px",
                        },
                    },
                    status: {
                        active: true,
                        name: "active",
                        type: "status",
                        wrapperClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12",
                    },
                    radioInput: {
                        wrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12",
                        active: true,
                        type: "radioInput",
                        name: "status",
                        label: "پیش فرض",
                        options: [
                            {
                                title: "بله",
                                value: 1,
                            },
                            {
                                title: "خیر",
                                value: 0,
                            },
                        ],
                    },
                    inputs: [
                        {
                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12",
                            name: "name",
                            label: "نام تنخواه گردان",
                            required: true,
                            primary: true,
                            maxLength: 32,
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5 style-padding-inputs",
                            name: "priceUnit",
                            type: "currency",
                            showInput: false,
                            label: "واحد پول",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12 offset-1 offset-xs-0",
                            type: "selectBox",
                            // addModal: {
                            //     props: {
                            //         component: "financial",
                            //         title: false,
                            //         closeButton: false,
                            //         onFinish: (token) => apiFinancialsList("bank", token),
                            //     },
                            // },
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                            name: "CurrencyId",
                            label: "نوع ارز",
                            primary: true,
                            showInput: true,
                            required: false,
                            options: "businessCurrencies",
                        },
                        {
                            name: "description",
                            label: "توضیحات",
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                    ],
                },
            },
        },
        {
            key: "cashier",
            name: "صندوق",
            form: {
                main: {
                    wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                    imagePicker: {
                        active: false,
                    },
                    accountingCode: {
                        wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12 offset-1 offset-xs-0",
                        active: true,
                        primary: true,
                        type: "accountingCode",
                        label: "کد حسابداری",
                        name: "accountingCode",
                        maxLength: 20,
                        options: [
                            {
                                label: "اتوماتیک",
                                value: true,
                            },
                            {
                                label: "دستی",
                                value: false,
                            },
                        ],
                        style: {
                            paddingRight: "60px",
                        },
                    },
                    status: {
                        active: true,
                        name: "active",
                        type: "status",
                        wrapperClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12",
                    },
                    radioInput: {
                        wrapperClass: "col-lg-3 col-md-3 col-sm-3 col-xs-12",
                        active: true,
                        type: "radioInput",
                        name: "status",
                        label: "پیش فرض",
                        options: [
                            {
                                title: "بله",
                                value: 1,
                            },
                            {
                                title: "خیر",
                                value: 0,
                            },
                        ],
                    },
                    inputs: [
                        {
                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12",
                            name: "name",
                            label: "نام صندوق",
                            required: true,
                            primary: true,
                            maxLength: 32,
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-5 col-md-5 col-sm-5 col-xs-5 style-padding-inputs",
                            name: "priceUnit",
                            type: "currency",
                            showInput: false,
                            label: "واحد پول",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                        {
                            wrapperClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12 offset-1 offset-xs-0",
                            type: "selectBox",
                            // addModal: {
                                //     props: {
                            //         component: "financial",
                            //         title: false,
                            //         closeButton: false,
                            //         onFinish: (token) => apiFinancialsList("bank", token),
                            //     },
                            // },
                            style: {
                                paddingRight: "60px",
                                paddingLeft: "50px",
                            },
                            name: "CurrencyId",
                            label: "نوع ارز",
                            primary: true,
                            showInput: true,
                            required: false,
                            options: "businessCurrencies",
                        },
                        {
                            name: "description",
                            type: "textarea",
                            label: "توضیحات",
                            wrapperClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                            style: {
                                paddingRight: "60px",
                            },
                        },
                    ],
                },
                tabs: [
                    {
                        key: "taxInformation",
                        name: "سامانه مودیان",
                        imgUrl: Document,
                        imgUrlShow: DocumentShow,
                        inputs: [
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                type: "text",
                                name: "taxMobile",
                                label: "شماره موبایل اینترنت بانک",
                                placeholder: "*******0912",
                                maxLength: 14,
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "taxPaymentSwitch",
                                type: "number",
                                label: "شماره سوئیچ پرداخت",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "taxPaymentTerminal",
                                type: "number",
                                label: "شماره ترمینال پرداخت",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                            {
                                wrapperClass: "col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs",
                                name: "taxStoreReceiverNumber",
                                type: "number",
                                label: "شماره پذیرنده فروشگاهی",
                                maxLength: 32,
                                placeholder: "12345678",
                            },
                        ],
                    },
                ],
            },
        },
    ],
};
